import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  actionText?: string;
  actionTo?: string;
  children?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  actionText,
  actionTo,
  children,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-col gap-3 md:mb-8 md:flex-row md:items-end md:justify-between">
      <div>
        {eyebrow && (
          <p className="mb-2 flex items-center gap-2 text-[11px] uppercase tracking-[0.28em] text-primary-400">
            <span className="h-px w-6 bg-primary-600" />
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-xl font-bold text-foreground-50 md:text-2xl">{title}</h2>
        {description && (
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-500">{description}</p>
        )}
      </div>

      <div className="flex items-center gap-3">
        {children}
        {actionText && actionTo && (
          <Link
            to={actionTo}
            className="group flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm text-foreground-300 transition-colors hover:text-primary-300"
          >
            {actionText}
            <span className="flex h-4 w-4 items-center justify-center transition-transform group-hover:translate-x-0.5">
              <i className="ri-arrow-right-line text-sm" />
            </span>
          </Link>
        )}
      </div>
    </div>
  );
}